import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch } from "../../../redux/store";
import { getRegisteredAddress } from "../redux/action/getRegisteredAddress";
import VerRegisteredAddress from "./verRegisteredAddress";
import VerCommunicationAddress from "./verCommunicationAddress";
import { getCommunicationAddress } from "../redux/action/getCommunicationAddress";

const AddressDetailsVerification: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { appId } = useParams();
  const customerId = Number(appId);

  const [showAddr, setShowAddr] = useState(false);
  const [showCAddr, setShowCAddr] = useState(false);

  const handleRegisteredClick = async () => {
    // // console.warn("Reg clicked");
    try {
      dispatch(getRegisteredAddress(customerId)).then(() => {
        setShowAddr(true);
      });
    } catch (error) {
      alert(error);
    }
  };

  const handleCommunicationClick = async () => {
    try {
      dispatch(getCommunicationAddress(customerId)).then(() => {
        setShowCAddr(true);
      });
    } catch (error) {
      // console.error("An error occured", error);
    }
  };

  return (
    <>
      <Accordion>
        <Accordion.Item eventKey="A1">
          <Accordion.Header onClick={handleRegisteredClick}>
            Registered Address
          </Accordion.Header>
          <Accordion.Body>
            {showAddr ? <VerRegisteredAddress /> : "Loading..."}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="A2">
          <Accordion.Header onClick={handleCommunicationClick}>
            Communication Address
          </Accordion.Header>
          <Accordion.Body>
            {showCAddr ? <VerCommunicationAddress /> : "Loading..."}
            {/* <VerCommunicationAddress /> */}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default AddressDetailsVerification;
